import { render, staticRenderFns } from "./ViewTaxComponent.vue?vue&type=template&id=785b187f&"
import script from "./ViewTaxComponent.vue?vue&type=script&lang=js&"
export * from "./ViewTaxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports